import type { Level } from '#@/levels.ts'
import type { LogRecord } from '#@/record.ts'

/**
 * One console call with one plain-object argument (R1). workerd serialises the object and Workers Logs indexes its
 * keys; `console[level]` provides the level (R2). The method is resolved at each call so a wrapper installed later,
 * such as Sentry's console instrumentation, is used.
 */
export function emitJson(level: Level, record: LogRecord): void {
  console[level](record)
}
